import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { Approval } from 'src/app/pages/approval/approval.component';

@Component({
  selector: 'FormApproval',
  templateUrl: './form-approval.component.html',
  styleUrls: ['./form-approval.component.scss']
})
export class FormApprovalComponent implements OnInit {

  @Input() public causes: Approval[];

  constructor() { }

  ngOnInit() {
    // console.log(this.causes);
  }

}
